module.exports = __webpack_public_path__ + "img/sentence_cta_en.e40eed6.svg";